import { AvailableBaseRoutes } from "../utils/constants";

export class AuthUtil {
  static getRedirectUrl = (): string => {
    return AvailableBaseRoutes.Portal;
  };
}
